//Get Region
export const GET_CITY = "GET_CITY";

//Insert Region
export const INSERT_CITY = "INSERT_CITY";

//Update Region
export const UPDATE_CITY = "UPDATE_CITY";

//Delete Region
export const DELETE_CITY = "DELETE_CITY";

//Insert Open Dialog
export const OPEN_CITY_DIALOG = "OPEN_CITY_DIALOG";

//Close Dialog
export const CLOSE_CITY_DIALOG = "CLOSE_CITY_DIALOG";

//toast
export const OPEN_CITY_TOAST = "OPEN_CITY_TOAST";
export const CLOSE_CITY_TOAST = "CLOSE_CITY_TOAST";
